/**
 * Translate a button press into the message the runtime expects.
 *
 * The action types mirror the runtime's own vocabulary - it skips NLU for
 * these, treating them as structured signals rather than free text.
 */
export const buttonClickHandler = onInvokeAction => {
  return async (payload, requestAttributes = {}) => {
    const { actionType } = requestAttributes;

    if (actionType === 'web_url') {
      await onInvokeAction(`${requestAttributes.payload || requestAttributes.url}`, requestAttributes);
      window.open(requestAttributes.url, '_blank', 'noopener,noreferrer');
      return;
    }

    if (actionType === 'go_to_step') {
      await onInvokeAction(`${requestAttributes.title}`, requestAttributes);
      return;
    }

    if (actionType === 'set_input') {
      await onInvokeAction(`${requestAttributes.inputValue}`, requestAttributes);
      return;
    }

    await onInvokeAction(payload, requestAttributes);
  };
};
